export default __webpack_public_path__ + "static/media/chop.e8032c0b.jpg";